import * as React from 'react'
import type { BlogCategoryType } from '../../services/contentfulPosts'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { getColor } from '@components/blog/helpers'
import { LinkWithUtms } from '../../actions/navigationActions'
type PropsType = {
  category: BlogCategoryType | null
}
function CategoryPillButton ({ category }: PropsType): React.ReactNode {
  if (!category) {
    return null
  }
  const { name } = category
  const lower = name.toLowerCase()
  return (
    <LinkWithUtms pathname={`/blog/categories/${lower}`}>
      <CategoryPill name={lower}>
        <CategoryPillLink
          name={lower}
        >
          {name}
        </CategoryPillLink>
      </CategoryPill>
    </LinkWithUtms>
  )
}

const CategoryPill = styled.div<any>`
  font-size: 14px;
  line-height: 21px;
  font-family: 'Good Sans Regular';
  border-radius: 39px;
  padding: 4px 20px 4px 20px;
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  padding: 4px 20px 4px 20px;
  ${(props: { name: string, isActive: boolean }): string => {
  return `border: 1px solid ${getColor(props.name)};`
  }}
  ${(props: { name: string }): string => {
  return `

      &:hover {
        background-color: ${getColor(props.name)};
        border: 1px solid ${getColor(props.name)};
        div {
          color: ${colors.violet};
          opacity: 1;
          text-decoration: none;
        }
      }
      `
}}
}}
`
const CategoryPillLink = styled.div<any>`
  font-size: 14px;
  ${(props: { name: string, isActive: boolean }): string => {
  if (props.isActive) {
    return `color: ${colors.violet};`
  }
  return `color: ${getColor(props.name)};`
}}
`

export default CategoryPillButton
